// extracted by mini-css-extract-plugin
export default {"text_right":"style_text_right__cBjFY","weigth_input_group":"style_weigth_input_group__D1QCB","weigth_input_group_select":"style_weigth_input_group_select__9d5I8"};